var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#767B85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1.02a1.83 1.83 0 0 0-1.826 1.83l-.067 9.48.996.007.067-9.483c0-.454.372-.824.83-.824h10.008V.021H4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.108.02c-1.043 0-1.892.86-1.892 1.917v10.639c0 .769-.618 1.395-1.378 1.395-.76 0-1.377-.626-1.377-1.395v-1.227a.501.501 0 0 0-.498-.504H.498a.501.501 0 0 0-.498.504v1.227c0 1.325 1.065 2.403 2.373 2.403v-1.008c-.76 0-1.377-.626-1.377-1.395v-.723h7.469v.723c0 1.325 1.064 2.403 2.373 2.403 1.309 0 2.374-1.078 2.374-2.403V4.693h2.29A.501.501 0 0 0 16 4.19V1.937C16 .88 15.151.02 14.108.02zm.896 3.665h-1.792V1.937c0-.5.402-.908.896-.908s.896.407.896.908v1.748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.274 13.971h8.448v1.008H2.274zM7.402 2.828H4.83a.501.501 0 0 0-.498.504c0 .278.223.504.498.504h2.572a.501.501 0 0 0 .498-.504.501.501 0 0 0-.498-.504zm2.988 2.016H4.83a.501.501 0 0 0-.498.505c0 .278.223.504.498.504h5.56a.501.501 0 0 0 .498-.504.501.501 0 0 0-.498-.505zm0 2.017H4.83a.501.501 0 0 0-.498.505c0 .278.223.504.498.504h5.56a.501.501 0 0 0 .498-.504.501.501 0 0 0-.498-.505zm0 2.017H4.83a.501.501 0 0 0-.498.504c0 .279.223.505.498.505h5.56a.501.501 0 0 0 .498-.505.501.501 0 0 0-.498-.504z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.f5cc1e4423e7c47a645f9a6495fbf9a3.svg";
export { ForwardRef as ReactComponent };